import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import ImportImages from '@src/importImages';
import Css from './Desktop.scss';

const Logo = ImportImages('/logo.png');

const desktop = props => {
  return (
    <header className={Css.header + ' d-flex align-items-center pl-3 pr-3'}>
      <Link
        to={'/'}
        className={'nav-anhor' + (props.hideNav ? ' mx-auto' : '')}
        data-goto={0}
      >
        <img
          src={Logo}
          className={'img-fluid float-left mr-3'}
          alt={'JetSuite Logo'}
        />
      </Link>

      {!props.hideNav && (
        <Nav>
          <NavItem>
            <Link to="/" className={'nav-link'} data-goto={1}>
              Who we are
            </Link>
          </NavItem>
          <NavItem>
            <Link to="/" className={'nav-link'} data-goto={2}>
              Why JetSuite
            </Link>
          </NavItem>
          <NavItem className={Css.dropdown}>
            <NavLink href="#">How to Fly</NavLink>
            <Nav className={Css['child-nav']}>
              <NavItem>
                <Link to={'/suitekey-membership'}>SuiteKey Membership</Link>
              </NavItem>
              <NavItem>
                <Link to={'/charter'}>Charter</Link>
              </NavItem>
              <NavItem>
                <Link to={'/wholesale'}>Wholesale</Link>
              </NavItem>
            </Nav>
          </NavItem>
          <NavItem className={Css.dropdown}>
            <NavLink href="#">Aircraft</NavLink>
            <Nav className={Css['child-nav']}>
              <NavItem>
                <Link to={'/our-aircraft'} className={''}>
                  Aircraft
                </Link>

                <Link
                  to={'/our-aircraft/p100'}
                  className={Css.subchild + ' nav-link'}
                  data-goto={2}
                >
                  Phenom 100
                </Link>
                <Link
                  to={'/our-aircraft/p300'}
                  className={Css.subchild + ' nav-link'}
                  data-goto={2}
                >
                  Phenom 300
                </Link>
                {/*<Link
                  to={'/our-aircraft/l650'}
                  className={Css.subchild + ' nav-link'}
                  data-goto={2}
                >
                  Legacy 650
                </Link>*/}
              </NavItem>
              <NavItem>
                <Link to={'/compare-aircraft'}>Compare Aircraft</Link>
              </NavItem>
              <NavItem>
                <Link to={'/safety'}>Safety</Link>
              </NavItem>
            </Nav>
          </NavItem>
          <NavItem>
            <Link
              to="/"
              className={'nav-link'}
              data-goto={3}
              onClick={() => {
                window.gtag('event', 'click', {
                  event_category: 'JS-Experiences-Engagement',
                  event_label: 'Homepage Menu - Experiences'
                });
              }}
            >
              Experiences
            </Link>
          </NavItem>
        </Nav>
      )}

      <Nav className={'ml-auto'}>
        {!props.isAuthenticated ? (
          <NavItem>
            <Link to="/quoting" className={'nav-link'}>
              Login
            </Link>
          </NavItem>
        ) : (
          <React.Fragment>
            <NavItem>
              <Link
                to={'/quoting'}
                className={'nav-link pointer'}
                onClick={props.logoutAction}
              >
                Log Out
              </Link>
            </NavItem>
            <span className={'mt-3'}>|</span>
            <NavItem>
              <Link to="/quoting" className={'nav-link'}>
                My Account
              </Link>
            </NavItem>
          </React.Fragment>
        )}

        <span className={'mt-3'}>|</span>
        <NavItem>
          <Link to="/subscribe" className={'nav-link'}>
            Subscribe
          </Link>
        </NavItem>
        <span className={'mt-3'}>|</span>
        <NavItem>
          <Link to="/suitekey-membership/join" className={'nav-link'}>
            Become a Member
          </Link>
        </NavItem>
      </Nav>
    </header>
  );
};

export default desktop;



// WEBPACK FOOTER //
// ./src/components/Header/Desktop/Desktop.js